import Vue from 'vue';

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    const event = event => {
      // console.log(binding);
      if (binding.expression !== undefined) {
        const expression = binding.expression.replace(/'/g, '');
        vnode.context.$emit(expression, event);
      }
    };
    el.addEventListener('click', event => {
      event.stopPropagation();
    });
    document.body.addEventListener('click', event);
  },
  unbind(el) {
    // , binding, vnode) {
    el.removeEventListener('click', event => {
      event.stopPropagation();
    });
    document.body.removeEventListener('click', event);
  }
});
